type Country = {
  code: string;
  name: string;
};

export type Address = {
  street: string;
  city: string;
  zipCode: string;
  country: string;
};

export type User = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
};

export interface EditClientFormValues {
  "client-id"?: string;
  "image-url"?: string;
  "client-name"?: string;
  "client-pricing-plan"?: string;
  "client-billing-interval"?: string;
  "client-products"?: Array<string>;
  "is-private-ledger"?: boolean;
  "address-street"?: string;
  "address-zip-code"?: string;
  "address-city"?: string;
  "country-select"?: Country | null;
}

export interface ReplaceUserOnClientFormValues {
  "main-user-first-name": string;
  "main-user-last-name": string;
  email: string;
}

export interface AddClientFormValues
  extends EditClientFormValues, ReplaceUserOnClientFormValues {}

export interface ClientApiResponse {
  id: string;
  teamsProfileUrl: string;
  name: string;
  mainUser: User;
  dateCreated: number;
  lastUpdated: number;
  isPrivateLedger: boolean;
  address: Address;
  imageUrl: string;
  products?: string[];
  pricingPlan?: {
    level: string;
    billingInterval?: string;
  };
}
export interface ImageUploadValues {
  "client-id"?: string;
  file: File | null;
}

export interface IndividualInvestment {
  clientName?: string;
  totalInvested?: number;
  note?: string;
  createdAt: number;
  unit: keyof UnitsOfSale;
  quantity: number;
  investmentId: string;
}

export interface InvestmentApiResponse {
  createdAt: number;
  unit: string;
  projectName: string;
  totalInvested: number;
  fromDate: number;
  toDate: number;
  individualInvestments?: IndividualInvestment[];
  solutionId: string;
}

export interface Investment {
  id: string;
  clientId: string;
  createdAt: number;
  solutionId: string;
  unit: string;
  quantity: number;
  projectName: string;
  totalInvested: number;
  individualInvestments?: IndividualInvestment[];
}

export interface AddInvestmentFormValues {
  "project-name": string;
  quantity: string | null;
  unit: string;
  id?: string;
  clientId?: string;
  note?: string;
  notifyClient: boolean;
}

export type RecordWithEnumeratedIndex<Key extends string, Value> = {
  [P in Key]: Value;
};

export type InitialDateValues<Name extends string> = RecordWithEnumeratedIndex<
  `${Name}-start-date` | `${Name}-end-date`,
  number
>;

const currentDate = Date.now();
const defaultMinDate = new Date("01/01/2018").getTime();
export const createInitialDateValues = <T extends string>(
  name: T,
  minDate: number = defaultMinDate,
  maxDate: number = currentDate,
): InitialDateValues<T> =>
  ({
    [`${name}-start-date`]: minDate,
    [`${name}-end-date`]: maxDate,
  }) as InitialDateValues<T>;

export interface Project {
  projectName: string;
  unit: string;
}
export interface AddInvestmentFormProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export type UnitsOfSale = {
  "m3 Kelp": string;
  "Tree(s)": string;
  Biodiversity: string;
  "Tonnes CO2": string;
  m2: string;
  "Minutes of monitoring footage": string;
  "Monitoring images": string;
  "Monitoring stations": string;
};

export type ClientInvestment = {
  name: string;
  id: string;
};

export type InvestedProjects =
  | Array<{
      name: string;
      value: number;
      unit: string;
    }>
  | Record<string, number>;
